
webpack.register(
    'components/alert-manager/alert-manager',
    function() {
        return require('components/alert-manager/alert-manager');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<div>\r\n    <can-import from=\"components/alert-manager/alert-manager\"/>\r\n\r\n    <alert-manager/> \r\n</div>\r\n");